import { warnIfOfflineNoCache } from '@school-manage/utils/offline';
import { createFileRoute } from '@tanstack/react-router';

import { NewsDetailError } from './-components/error/NewsDetailError';
import { NewsDetail } from './-components/NewsDetail';
import { NewsDetailSkeleton } from './-components/pending/NewsDetailSkeleton';
import { useNewsDetail } from './-logic/useNewsDetail';
import { NewsDetailContext } from './-logic/useNewsDetailContext';

export const Route = createFileRoute('/_authed/news/$newsId')({
  beforeLoad: ({ context: { queryClient }, location, params: { newsId } }) => {
    warnIfOfflineNoCache(location, [
      queryClient.getQueryData(['news-detail', { newsId }]),
    ]);
  },
  component: NewsDetailPage,
  errorComponent: NewsDetailError,
  pendingComponent: NewsDetailSkeleton,
});

function NewsDetailPage() {
  return (
    <NewsDetailContext.Provider value={useNewsDetail()}>
      <NewsDetail />
    </NewsDetailContext.Provider>
  );
}
